import {gql, QueryOptions} from '@apollo/client';
import {DocumentNode} from 'graphql';

import {getFragmentWrapper} from 'graphql-client/declarative-translations/external/getFragmentWrapper';
import ExtractByTypename from 'graphql-client/ExtractByTypename';
import {isInaccessible} from 'graphql-client/InaccessibleInfo';

import {
  CanvasVersionFileStateQuery,
  CanvasVersionFileStateQueryVariables,
} from './__generated/CanvasVersionFileStateQuery';

export const CANVAS_VERSION_FILE_STATE_QUERY: DocumentNode = gql`
  query CanvasVersionFileStateQuery($canvasVersionId: StrictString!)
  @skipAudit
  @engComponent(name: CANVAS_CORE) {
    canvasVersion(id: $canvasVersionId) {
      ...CanvasVersionFileStateGraphQL
      ...InaccessibleInfoGraphQL
    }
  }
  ${getFragmentWrapper('CanvasVersionFileState').fragment}
  ${getFragmentWrapper('InaccessibleInfo').fragment}
`;

export type CanvasVersionFileStateGraphQL = ExtractByTypename<
  CanvasVersionFileStateQuery['canvasVersion'],
  'CanvasVersionNode'
>;

export function getCanvasVersionFileStateQueryOptions(
  canvasVersionId: string
): QueryOptions<CanvasVersionFileStateQueryVariables> {
  return {
    query: CANVAS_VERSION_FILE_STATE_QUERY,
    variables: {canvasVersionId},
  };
}

export function canvasVersionFileStateDataToAttributes(data: CanvasVersionFileStateQuery): {name?: string} {
  const {canvasVersion} = data;
  return isInaccessible(canvasVersion) ? {} : {name: canvasVersion.definition.name};
}
